import type { AiUsageSource } from "./aiUsageSources";

export const CONNECTOR_USAGE_SOURCES = [
  "workflow_run",
  "workflow_builder",
  "step_test",
  "connection_test",
  "audit_log_delivery",
  "git_sync",
  "other",
] as const;

export type ConnectorUsageSource = (typeof CONNECTOR_USAGE_SOURCES)[number];

export const CONNECTOR_USAGE_SOURCE_LABELS: Record<
  ConnectorUsageSource,
  string
> = {
  workflow_run: "Workflow run",
  workflow_builder: "Workflow builder",
  step_test: "Step tests",
  connection_test: "Connection tests",
  audit_log_delivery: "Audit log delivery",
  git_sync: "Git sync",
  other: "Other",
};

const SOURCE_BY_PURPOSE: Record<string, ConnectorUsageSource> = {
  step: "workflow_run",
  scheduled_step: "workflow_run",
  ai_execute: "workflow_builder",
  step_test: "step_test",
  step_test_capture: "step_test",
  connection_test: "connection_test",
  audit_log_destination: "audit_log_delivery",
  git_sync: "git_sync",
};

export function connectorUsageSourceForPurpose(
  purpose: string
): ConnectorUsageSource {
  return SOURCE_BY_PURPOSE[purpose] ?? "other";
}

const SOURCE_BY_AI_USAGE: Partial<Record<AiUsageSource, ConnectorUsageSource>> =
  {
    workflow_builder: "workflow_builder",
    workflow_run: "workflow_run",
  };

export function connectorUsageSourceForAiUsage(
  source: AiUsageSource
): ConnectorUsageSource {
  return SOURCE_BY_AI_USAGE[source] ?? "other";
}

export function connectorUsageSourceLabel(
  source: string | null | undefined
): string {
  return (
    CONNECTOR_USAGE_SOURCE_LABELS[source as ConnectorUsageSource] ?? "Other"
  );
}
